import styled, { keyframes } from "styled-components";
import React from "react";
import { Icon, Label } from 'semantic-ui-react'
import AddMenu from './AddMenu'


const AddTag = ({categories,missing}) =>{

	const [open,setOpen] = React.useState(false)

	return (
		<div style={{position:'relative'}}>
		 <Label color={missing?'orange':'blue'} as='a' onClick={()=>setOpen(true)}>{missing?'2 Missing mandatory tags':'Add tags'}  
				<Icon name='add' style={{marginLeft:5}}/></Label>
		<AddMenu categories={categories} open={open} setOpen={()=>setOpen(false)}/>
		</div>

		)
}

export default AddTag